import React from 'react';
import './PromotionStateLive.css';
import { useAsgMarquee } from '../../../../../../shared/src/hooks/use-asg-animations.hook';
import { JsxUtilService } from '../../../../../../shared/src/services/util/jsx-util.service';

export const PromotionStateLive = () => {
    const { animatedContent } = useAsgMarquee({
        contentToAnimate: JsxUtilService.multiplyJsxElement(
            (<span className="asg-promotion-fold-thumbnail__state-live-item">LIVE</span>),
            20,
        ),
        gap: '24px',
        animationDurationSec: 40,
    });

    return (
        <div className="asg-promotion-fold-thumbnail__state-live">
            {animatedContent}
        </div>
    );
};
